"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Article = _interopRequireDefault(require("@insided/destination/icons/Article"));

var _Conversation = _interopRequireDefault(require("@insided/destination/icons/Conversation"));

var _Question = _interopRequireDefault(require("@insided/destination/icons/Question"));

var _Ideation = _interopRequireDefault(require("@insided/destination/icons/Ideation"));

var _Answer = _interopRequireDefault(require("@insided/destination/icons/Answer"));

var _ExternalLink = _interopRequireDefault(require("@insided/destination/icons/ExternalLink"));

var _Calendar = _interopRequireDefault(require("@insided/destination/icons/Calendar"));

var _ProductUpdate = _interopRequireDefault(require("@insided/destination/icons/ProductUpdate"));

var _classnames = _interopRequireDefault(require("classnames"));

var _typeGuards = require("./typeGuards");

var iconComponents = {
  article: _Article.default,
  conversation: _Conversation.default,
  question: _Question.default,
  ideation: _Ideation.default,
  answer: _Answer.default,
  externalLink: _ExternalLink.default,
  calendar: _Calendar.default,
  productUpdate: _ProductUpdate.default
};

/**
 * Determines the appropriate icon type for a search result based on its content type and properties.
 * Uses early returns to reduce cognitive complexity.
 *
 * @param hit - The search result to determine icon for
 * @returns The icon type to display
 */
var getIconType = function getIconType(hit) {
  // External results get external link icon
  if (!(0, _typeGuards.isCommunityResult)(hit)) {
    return 'externalLink';
  } // Answered questions get answer icon


  if (hit.content_type === 'question' && hit.has_answer) {
    return 'answer';
  } // Events get calendar icon


  if (hit.content_type === 'event') {
    return 'calendar';
  } // All other community content types map directly to their icon


  return hit.content_type;
};
/**
 * Renders an icon for search results based on content type.
 * Supports article, conversation, question, ideation, answer, external link, calendar, and product update types.
 * Automatically determines the appropriate icon based on the search result properties.
 */


var SearchResultIcon = function SearchResultIcon(_ref) {
  var hit = _ref.hit;
  var iconType = getIconType(hit);
  var IconComponent = iconComponents[iconType];
  return (0, _preact.h)("span", {
    className: (0, _classnames.default)('algolia-hit-item-icon', "icon-".concat(iconType))
  }, (0, _preact.h)(IconComponent, {
    className: "algolia-hit-item--icon",
    width: 20,
    height: 20
  }));
};

var _default = SearchResultIcon;
exports.default = _default;